//Próprios
import api from "../../../services/api"
import {writeStorage,readDataStorage } from "../../../utils/storage/storage";
import React, { useCallback,useState } from 'react'
import { useProgress } from '../../../hooks/progress';
import sol from './Images/Sol.png'
import usina from './Images/Usina.png'
import porco from './Images/porco.png'
import cofrinho from './Images/Cofrinho.svg'
import nuvem from './Images/Nuvem.png'
import carro from './Images/carro.png'
import arvore from './Images/Arvore.png'
import info from './Images/Info.svg'
import Toast from "../../Toast/Toast";
import errorIcon from "../../Toast/Image/error.svg";

import Percent from './Images/Percent.png'
import Line from './Images/Line.png'
import Tomada from './Images/Tomada.png'
import Table from './Images/Table.png'
import Button from '@mui/material/Button';
import { 
  DivButton
} from './css/styles'; 

//CSS
import "./css/GridGrafico.css";
import "./css/Mobile/GridGraficoMobile.css";
import "./css/carousel.css"

export default function GridGrafico() {

  const {idCard} = readDataStorage('home');
  const {
    consumoMinimo,
    mensalidade,
    kmCarroEletrico,
    mediaFinal,
    carbonoEvitado,
    arvoresCultivadas,
    economiaAnual
  } = readDataStorage('consumo');

  const { setLoad } = useProgress();

  const valueMensalidade = mensalidade
   const valueMediaFinal = (mediaFinal?.toFixed(0))
    
   const [list, setList] = useState([]);

   const showToast = useCallback((type) => {
    let toastProperties = null;
 
     const id = Math.floor(Math.random() * 101 + 1);
     switch (type) {
       case "error":
         toastProperties = {
           id,
           title: "",
           description: "Erro ao enviar dados",
           backgroundColor: "#D72828",
           icon: errorIcon,
         };
         break;
       default:
         setList([]);
     }
 
     setList([...list, toastProperties]);
   }, [list]);

   const handleCard =  useCallback( async () => {
    
    await api.get('/csp/cliente/consultar/card/'+idCard).then((res) => {
       if (res.status === 200) {

            writeStorage({
               'key': 'card',
               'object': {
                "NomeTitularConta":res.data["empresa"],
                "OndeEconomizar":res.data["onde_voc_quer_economizar"],
                "Pessoa":res.data["tipo"],
                "CNPJrepresentante":res.data["cnpj_do_representante_1"],
                "Estado": res.data["estado"],
                "Cidade": res.data["cidade"],
                "Bairro": res.data["bairro"],
                "Rua": res.data["rua"],
                "Numero": res.data["n_mero"],
                "Complemento": res.data["complemento"],
                "Classe":res.data["classe"],
                "Subclasse":res.data["subclasse"],
                "Jan":res.data["jan"],
                "Fev":res.data["fev"],
                "Mar":res.data["mar"],
                "Abr":res.data["abr"],
                "Mai":res.data["mai"],
                "Jun":res.data["jun"],
                "Jul":res.data["jul"],
                "Ago":res.data["ago"],
                "Set":res.data["set"],
                "Out":res.data["out"],
                "Nov":res.data["nov"],
                "Dez":res.data["dez"],
                "MediaConsumo":res.data["m_dia_de_consumo"],
                "FormaPagamento":res.data["forma_de_pagamento"],
                "CEPvalidoCard": 1,
                "RazaoSocialCard":res.data["raz_o_social"],
                "Email":res.data["email"],
                "EmailDoResponsavel":res.data["email_do_respons_vel_legal"],
                "TelefoneTitularConta":res.data["telefone_do_titular_da_conta"],
                "TelefoneResponsavelLegal":res.data["telefone_do_respons_vel_legal"],
                "cpfCnpjCard":res.data["tipo"] === "PJ" ? res.data["cnpj"] : res.data["cpf"],
                "DataNascimentoTitular":res.data["data_de_nascimento_do_titular"]?.split(" ")[0].split("/").reverse().join('-'),
                "NomeResponsavelLegal":res.data["nome_do_respons_vel_legal"],
                "CPF":res.data["tipo"]=== "PF" ? res.data["cpf"] : res.data["cpf_do_respons_vel_legal"],
                "CEP":res.data["cep"],
                "NumeroInstalacao": res.data["n_mero_da_instala_o_cemig_1"],
                "DataVencimentoFatura":res.data["data_de_vencimento_da_fatura_cemig"],
                "Banco":res.data["banco"],
                "CodBanco":res.data["codban"],
                "Agencia":res.data["ag_ncia"],
                "Conta":res.data["conta"],
                "OptanteSimples":res.data["empresa_optante_pelo_simples"],
                "Concessionaria":res.data["concession_ria"],
                "TelefoneLigacao":res.data["telefone_contato_para_liga_o"]
             }
             });
           setLoad(false);
           window.location.href = '/onboarding/step/3'
       }else{
          showToast('error')
          setLoad(false)
        }
    })
  },[showToast,setLoad,idCard]);


    const postData = useCallback( async () => {
      setLoad(true);
       await api.post('/csp/usuario/alterar/aceiteProposta/',
       {
        "aceiteProposta":1,
        "idCard":idCard,
     }).then(res => {
      if (res.status === 200) {
        setLoad(false);
        handleCard();
      }else{
        showToast('error')
        setLoad(false)
      }}
          )
   },[setLoad,showToast,handleCard,idCard]);

const handleChangeStepperBack = useCallback(() => {
  api.get('/csp/cliente/consultar/card/'+idCard).then((res) => {
    writeStorage({
      'key': 'card',
      'object': {
        "NomeTitularConta":res.data["empresa"],
        "OndeEconomizar":res.data["onde_voc_quer_economizar"],
        "Pessoa":res.data["tipo"],
        "CNPJrepresentante":res.data["cnpj_do_representante_1"],
        "Estado": res.data["estado"],
        "Cidade": res.data["cidade"],
        "Bairro": res.data["bairro"],
        "Rua": res.data["rua"],
        "Numero": res.data["n_mero"],
        "Complemento": res.data["complemento"],
        "Classe":res.data["classe"],
        "Subclasse":res.data["subclasse"],
        "Jan":res.data["jan"],
        "Fev":res.data["fev"],
        "Mar":res.data["mar"],
        "Abr":res.data["abr"],
        "Mai":res.data["mai"],
        "Jun":res.data["jun"],
        "Jul":res.data["jul"],
        "Ago":res.data["ago"],
        "Set":res.data["set"],
        "Out":res.data["out"],
        "Nov":res.data["nov"],
        "Dez":res.data["dez"],
        "MediaConsumo":res.data["m_dia_de_consumo"],
        "FormaPagamento":res.data["forma_de_pagamento"],
        "CEPvalidoCard": 1,
        "RazaoSocialCard":res.data["raz_o_social"],
        "Email":res.data["email"],
        "EmailDoResponsavel":res.data["email_do_respons_vel_legal"],
        "TelefoneTitularConta":res.data["telefone_do_titular_da_conta"],
        "TelefoneResponsavelLegal":res.data["telefone_do_respons_vel_legal"],
        "cpfCnpjCard":res.data["tipo"] === "PJ" ? res.data["cnpj"] : res.data["cpf"],
        "DataNascimentoTitular":res.data["data_de_nascimento_do_titular"]?.split(" ")[0].split("/").reverse().join('-'),
        "NomeResponsavelLegal":res.data["nome_do_respons_vel_legal"],
        "CPF":res.data["tipo"]=== "PF" ? res.data["cpf"] : res.data["cpf_do_respons_vel_legal"],
        "CEP":res.data["cep"],
        "NumeroInstalacao": res.data["n_mero_da_instala_o_cemig_1"],
        "DataVencimentoFatura":res.data["data_de_vencimento_da_fatura_cemig"],
        "Banco":res.data["banco"],
        "CodBanco":res.data["codban"],
        "Agencia":res.data["ag_ncia"],
        "Conta":res.data["conta"],
        "OptanteSimples":res.data["empresa_optante_pelo_simples"],
        "Concessionaria":res.data["concession_ria"],
        "TelefoneLigacao":res.data["telefone_contato_para_liga_o"]
    }
    });
    if (res.status === 200) {
      window.location.href = '/onboarding/step/1';
  }
  })

},[idCard]);
const handleChangeStepperNext = useCallback(() => {
    postData();
    writeStorage({
      'key': 'economia',
      'object': {
        "aceiteProposta":1,
      }
    });
},[postData]);
function numberPoint(numero) {
   // eslint-disable-next-line
  var numero = numero.toFixed(2).split('.');
  numero[0] = numero[0].split(/(?=(?:...)*$)/).join('.');
  return numero.join(',');
}
return (
<>
<Toast toastList={list} autoDelete={true} />
  <title>AXS</title>
    <div className="TotalGrafico">
          <div className="TituloGridGrafico">Detalhamento da economia</div>
            <div className="Espaco"></div>
            <div className="GridInicio">
              <div className="GridRetanguloProposta">
                <div className="RetanguloProposta"><img className="ImgRetanguloProposta" src={porco} alt="logo" /> 
                  <div className="TextoRetanguloProposta">Mensalidade AXS
                    <span> <img src={info} alt="" id="mouse" width={20}/>
                      <div className="col-md-2" id="show">
                      A mensalidade da AXS possuí um valor fixo. 
                      Esse valor corresponde a assinatura mensal, ou seja, 
                      é uma taxa referente a cota de uso dos painéis solares das nossas usinas.
                      Ao pagar a mensalidade da AXS, você irá usufruir de uma energia limpa, 
                      sustentável e mais barata que a convencional, 
                      porque é gerada pelos painéis solares contratados.
                        
                        </div>
                    </span>
                    <div className="TextoRoxo">R$ {numberPoint(Number(valueMensalidade))}</div>
                  </div>
                </div>
                <div className="RetanguloProposta"><img className="ImgRetanguloProposta" src={sol} alt="logo" /><div className="TextoRetanguloProposta">Geração anual prevista <div className="TextoRoxo">{numberPoint(Number(consumoMinimo))}<span className="TextoRoxoRetangulo"> kWh</span></div></div></div>
                <div className="RetanguloProposta"><img className="ImgRetanguloProposta" src={usina} alt="logo" /><div className="TextoRetanguloProposta">Consumo médio previsto<div className="TextoRoxo">{(numberPoint(Number(valueMediaFinal)))} <span className="TextoRoxoRetangulo"> kWh</span></div></div></div>
              </div>
              </div>
              <div className="Graficos">
              <div className="ImgGraficos" ><img alt=""src={Tomada}/><div className="DivGraficos">ENERGIA SUSTENTÁVEL</div></div>
              <div className="ImgGraficos ImgGraficosRotate" ><img alt=""src={Line}/></div>
              <div className="ImgGraficos" ><img alt=""src={Table}/><div className="DivGraficos">SEM TAXA DE ADESÃO E FIDELIDADE</div></div>
              <div className="ImgGraficos ImgGraficosRotate" ><img alt=""src={Line}/></div>
              <div className="ImgGraficos" ><img alt=""src={Percent}/><div className="DivGraficos">COM DESCONTO</div></div>
            </div> 
            <div className="Espaco"></div>
            <div className="GridFinal">
              <div className="GridRetanguloAmbiente">
                  <div className="RetanguloAmbiente"><img className="ImgRetanguloAmbiente" style={{height:'20'}}src={nuvem} alt="logo" /> <div className="TextoRetanguloProposta">Emissão de C02 evitada <div className="TextoRoxo">{(numberPoint(Number(carbonoEvitado)))} <span className="TextoRoxoRetangulo">kg</span></div></div></div>
                  <div className="RetanguloAmbiente"><img className="ImgRetanguloAmbiente" src={arvore} alt="logo" /><div className="TextoRetanguloProposta">Árvores poupadas<div className="TextoRoxo">{(Number(arvoresCultivadas)).toFixed(0)}</div></div></div>
                  <div className="RetanguloAmbiente"><img className="ImgRetanguloAmbiente" src={carro} alt="logo" /><div className="TextoRetanguloProposta">KMs em carro elétrico<div className="TextoRoxo">{(numberPoint(Number(kmCarroEletrico)))} <span className="TextoRoxoRetangulo">km</span></div></div></div>
                </div>
                <div className="RetanguloCardSlider">
                  <img className="ImgRetanguloGG" src={cofrinho} alt="logo" /> 
                    <div className="TextoRetanguloGG">Economize anualmente até: 
                      <div className="TextoRoxoGG"style={{marginTop:"10px"}}>R$ {numberPoint(Number(economiaAnual))}</div>
                    <div className="TextoMini" style={{marginTop:"10px"}}>
                      *A simulação considera consumidores(B1) conectados em 
                      baixa tensão, ligação bifásica, e bandeira tarifária escassez hídrica.
                    </div>
                  </div>
                </div>
                </div>
            <div className="GridButtonsGrafico">
                <DivButton>
                  <Button id="btnStep2Back" className='buttonBack' onClick={handleChangeStepperBack} type="submit">Voltar</Button>
                </DivButton>
                <DivButton>
                  <Button id="btnStep2Next" className='buttonSend' onClick={handleChangeStepperNext} type="submit">Continuar</Button>
                </DivButton>
          </div>
    </div></>
    );
}